module.exports = __webpack_public_path__ + "static/header_contact-53d49da9da508d31236cc9ee4221a4b7.jpg";